import styled, { css } from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

const distanceBetweenRows = 8;
const borderColorLight = Colors.GreyDarkerMiddle;
const borderColorDark = Colors.GreyDarkerMiddle;
const borderColorError = Colors.RedMiddle;
const borderRadius = 4;
const bgColor1Light = Colors.GreyLightest;
const bgColor1Dark = Colors.GreyLightest;
const bgColor2Light = Colors.Lighter;
const bgColor2Dark = Colors.Lighter;
const textColorLight = Colors.Dark;
const textColorDark = Colors.Dark;

export const LegendNameContainer = styled.div`
  margin-bottom: 16px;
  width: 100%;
  max-width: 656px;
`;

export const ColorPickerContainer = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;

  border: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  border-top-left-radius: ${borderRadius}px;
  border-bottom-left-radius: ${borderRadius}px;
  border-right: none;
  padding: 0 4px;
`;

export const QueryTypeContainer = styled.div`
  grid-column-start: 2;
  grid-column-end: 3;
  width: 84px;

  border: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  border-right: none;
  background-color: ${ct({ Dark: bgColor1Dark, Light: bgColor1Light })};
`;

export const ProductsTitleContainer = styled.div`
  grid-column-start: 3;
  grid-column-end: 4;

  border: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  border-right: none;
  background-color: ${ct({ Dark: bgColor2Dark, Light: bgColor2Light })};
  white-space: nowrap;
  padding: 0 12px;
  justify-items: center;
`;

export const ProductsValueContainer = styled.div<{ $isFocused: boolean }>`
  grid-column-start: 4;
  grid-column-end: 5;
  grid-row: 1;

  border: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  border-right: none;

  ${(props) =>
    props.$isFocused &&
    css`
      position: relative;
      grid-column-end: 7;
      z-index: 1;
      border: none;
    `}

  &[data-error='true'] {
    border: 1px solid ${ct({ Dark: borderColorError, Light: borderColorError })};
  }
`;

export const DisplayTitleContainer = styled.div`
  grid-column-start: 5;
  grid-column-end: 6;
  grid-row: 1;

  border: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  border-right: none;
  background-color: ${ct({ Dark: bgColor2Dark, Light: bgColor2Light })};
  white-space: nowrap;
  padding: 0 12px;
  justify-items: center;
`;

export const DisplayValueContainer = styled.div`
  grid-column-start: 6;
  grid-column-end: 7;
  grid-row: 1;

  border: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  border-top-right-radius: ${borderRadius}px;
  border-bottom-right-radius: ${borderRadius}px;

  display: flex;
  align-items: center;
  position: relative;

  &[data-error='true'] {
    border: 1px solid ${ct({ Dark: borderColorError, Light: borderColorError })};
  }
`;

export const ActionsContainer = styled.div`
  && {
    display: flex;
    gap: 16px;
    align-items: center;
    white-space: nowrap;
    padding-left: 16px;
  }
`;

export const RowConnector = styled.div<{ isLast?: boolean }>`
  height: auto !important;
  grid-column-start: 1;
  grid-column-end: 2;

  position: relative;

  &:before {
    content: '';
    position: absolute;
    display: block;
    top: -${distanceBetweenRows}px;
    height: 25px;
    left: 50%;
    width: 50%;
    border-bottom-left-radius: ${borderRadius}px;
    border-bottom: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
    border-left: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  }

  ${({ isLast }) => {
    return (
      !isLast &&
      css`
        &:after {
          content: '';
          position: absolute;
          display: block;
          top: 0;
          bottom: 0;
          height: 100%;
          left: 50%;
          width: 50%;
          border-left: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
        }
      `
    );
  }}
`;

export const RowTitleContainer = styled.div`
  grid-column-start: 2;
  grid-column-end: 3;

  border: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  border-top-left-radius: ${borderRadius}px;
  border-bottom-left-radius: ${borderRadius}px;
  border-right: none;
  white-space: nowrap;
  background-color: ${ct({ Dark: bgColor2Dark, Light: bgColor2Light })};
  padding: 0 12px;
  justify-items: center;
`;

export const RowValueContainer = styled.div`
  height: auto !important;
  grid-column-start: 3;
  grid-column-end: 7;

  border: 1px solid ${ct({ Dark: borderColorDark, Light: borderColorLight })};
  border-top-right-radius: ${borderRadius}px;
  border-bottom-right-radius: ${borderRadius}px;

  &[data-error='true'] {
    border: 1px solid ${ct({ Dark: borderColorError, Light: borderColorError })};
  }
`;

export const QueryLayoutStyled = styled.div`
  display: grid;
  row-gap: ${distanceBetweenRows}px;
  grid-template-columns:
    minmax(min-content, 20px) minmax(min-content, 20px) minmax(min-content, 20px) 1fr
    minmax(min-content, 20px) 1fr minmax(min-content, 20px);
  width: 100%;
  font-size: 12px;
  color: ${ct({ Dark: textColorDark, Light: textColorLight })};

  & button {
    font-size: 12px;
  }

  & > * {
    display: grid;
    align-items: center;
    box-sizing: border-box;
    height: 34px;
    min-height: 34px;
  }
`;
